module.exports = __webpack_public_path__ + "img/icon2.f45753db.png";